import {
  Backdrop,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  getPayoutDetails,
  getPayoutEventDetails,
} from "../../../services/services";
import { parseDate, parseCurrency } from "../../../utils/tableFunctions";
import { Clear } from "@mui/icons-material";
import { startCase } from "lodash";
import { linkTextStyle, styles } from "../../../utils/styles";
import { handleOpenLink } from "../../../utils/appUtils";

const PayoutDetails = () => {
  const [payoutDetails, setPayoutDetails] = useState();
  const [loaded, setLoaded] = useState();
  const { id } = useParams();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const action = useQuery().get("action");
  const mobile = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  useEffect(() => {
    if (action) {
      getPayoutEventDetails(id, setPayoutDetails, setLoaded);
    } else {
      getPayoutDetails(id, setPayoutDetails, setLoaded);
    }
  }, [action, id]);

  const handleBack = () => window.close();

  const BankDetails = () => {
    const allDetails = [];
    for (const [key, value] of Object.entries(payoutDetails.bank_details)) {
      if (key !== "id") {
        allDetails.push(
          <TextField
            key={key}
            label={startCase(key)}
            value={value || "N/A"}
            sx={{ m: 1, width: "25ch" }}
            disabled
          />
        );
      }
    }
    return allDetails;
  };

  return (
    <Container>
      <Stack
        direction="row"
        sx={{
          ...styles.flexBetween,
          mb: 2,
        }}
      >
        <Typography variant={mobile ? "h5" : "h3"}>
          Merchant Payout Details
        </Typography>

        <Button
          variant="outlined"
          onClick={handleBack}
          endIcon={<Clear />}
        >
          Back
        </Button>
      </Stack>
      {loaded && action === "true" && (
        <Typography variant="h6" sx={{ mb: 2 }}>
          Action: {payoutDetails.action && payoutDetails.action}
        </Typography>
      )}
      {loaded ? (
        <Card sx={{ p: 3 }}>
          <Grid
            container
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 2, sm: 2, md: 2 }}
            sx={{ mt: 5 }}
          >
            <Grid item xs={6} md={6}>
              <Box
                sx={{
                  height: "100%",
                  p: 3,
                  border: "1px solid #999",
                  borderRadius: 2,
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Merchant Name</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={7}
                    sx={{ ...linkTextStyle }}
                    onClick={() => handleOpenLink(`/3/app/merchant-details/${payoutDetails.merchant.id}`)}
                  >
                    {payoutDetails.merchant.name}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Payment Host</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {payoutDetails.payment_host.name}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Annual Fee</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {payoutDetails.annual_fee && payoutDetails.annual_fee}
                  </Grid>{" "}
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Annual Fee Period
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {payoutDetails.annual_fee_period &&
                      payoutDetails.annual_fee_period}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Annual Fee Start Date
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {payoutDetails.annual_fee_start_date &&
                      parseDate(payoutDetails.annual_fee_start_date)}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={6} md={6}>
              <Box
                sx={{
                  height: "100%",
                  p: 3,
                  border: "1px solid #999",
                  borderRadius: 2,
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Created by</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {payoutDetails.created_by
                      ? payoutDetails.created_by
                      : "N/A"}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Created on</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {payoutDetails.created_at
                      ? parseDate(payoutDetails.created_at)
                      : "N/A"}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Created on</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {parseDate(payoutDetails.updated_at)}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Min Payout Amount
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {payoutDetails.minimum_payout_amount}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Security Deposit
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {payoutDetails.security_deposit
                      ? payoutDetails.security_deposit
                      : "N/A"}
                  </Grid>{" "}
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      One-time Fixed Charge
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {payoutDetails.fixed_amount
                      ? parseCurrency(payoutDetails.fixed_amount)
                      : "N/A"}
                  </Grid>{" "}
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Security Deposit
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {payoutDetails.rolling_amount
                      ? parseCurrency(payoutDetails.rolling_amount)
                      : "N/A"}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
          <Divider sx={{ my: 3 }} />
          <Typography variant="h4" sx={{ mb: 2 }}>
            Bank Details
          </Typography>
          <Box
            sx={{
              "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
          >
            <BankDetails />
          </Box>
        </Card>
      ) : (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Container>
  );
};

export default PayoutDetails;
